// Placeholder for Integration model views
import { getRoot } from "mobx-state-tree";

export const integrationViews = self => ({
  // Example view (can be removed or modified)
  get isActive() {
    return self.status === 'ENABLED';
  },
  get root() {
    return getRoot(self)
  }
  // Add other views here
});
